var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.Button,
        {
          staticClass: "rounded-0",
          attrs: {
            disabled: _setup.isSaving,
            title: "Save and close",
            "active-class": "btn-warning",
            "active-value": _setup.isModified,
          },
          nativeOn: {
            click: function ($event) {
              return _setup.onClick.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "bi-chevron-right" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }